import { render, staticRenderFns } from "./PricesView.vue?vue&type=template&id=0b5a4ef7&"
import script from "./PricesView.vue?vue&type=script&lang=js&"
export * from "./PricesView.vue?vue&type=script&lang=js&"
import style0 from "./PricesView.vue?vue&type=style&index=0&id=0b5a4ef7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports